import styled from '@emotion/styled';
import theme from '../../theme';

export const Wrapper = styled.div`
  background-color: ${theme.colors.gray4};
  height: 1px;
  width: 479px;
`;
